/**
 * Fulfillment Countdown Timer
 * Handles dynamic visibility for shipping deadline countdown
 * Handles edge cases when pages stay open past cutoff times
 */

(function () {
  "use strict";

  /**
   * Initialize fulfillment countdown timer monitoring
   */
  function initFulfillmentCountdown() {
    // Target fulfillment countdown timers (those inside data-countdown-fulfillment containers)
    const timerContainers = document.querySelectorAll("[data-countdown-fulfillment]");
    const messageContainers = document.querySelectorAll("[data-countdown-fulfillment-message]");

    // Listen for when the countdown timer expires (handles expiration-behavior="hide")
    timerContainers.forEach((container) => {
      const timer = container.querySelector("countdown-timer");
      if (timer) {
        timer.addEventListener("expired", () => {
          // Timer expired - hide the container
          container.style.display = "none";
        });
      }
    });

    // Note: Server-side Liquid logic handles most visibility logic
    // This JavaScript mainly handles expiration events and edge cases
  }

  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initFulfillmentCountdown);
  } else {
    initFulfillmentCountdown();
  }
})();
